import { render, staticRenderFns } from "./GoodsSpec.vue?vue&type=template&id=2b20a13e&scoped=true"
import script from "./GoodsSpec.vue?vue&type=script&lang=ts"
export * from "./GoodsSpec.vue?vue&type=script&lang=ts"
import style0 from "./GoodsSpec.vue?vue&type=style&index=0&id=2b20a13e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20a13e",
  null
  
)

export default component.exports